import React, { Component } from 'react';

import charactorIcon from '../../../assets/image/charactor2.svg';

class SelectItem extends Component {
  render() {
    const { tab, active } =  this.props;

    const defaultClassName = active ? 'BoxShadow SelectItemActive' : 'BoxShadow SelectItem';
    const tabClassName = active ? 'TabActive' : 'Tab';

    const className = tab ? tabClassName : defaultClassName;

    const textStyle = this.props.charactor ? 'SelectItemTextCharacter' : '';

    const tabFooter = tab ? <div className="SelectItemTabFooter" ></div> : null;

    const charactor = this.props.charactor ? <img className="SelectItemLogo" src={charactorIcon}  alt="charactor" /> : null;

    return (
      <div className={tab ? 'SelectItemContainer SelectItemContainerTab' : 'SelectItemContainer'} >
        <div
          className={`SelectItemWrapper ${tab ? ' SelectItemWrapperTab ' : ''}${className}`}
          onClick={this.props.onClick}
        >
          {charactor}
          <div className={textStyle} >
            {this.props.title}
          </div>
        </div>
        {tabFooter}
      </div>
    );
  };
};

export default SelectItem;
